export default __webpack_public_path__ + "static/team-foto-c0bd66785c86922d94948f8459eec226.jpg";